import React, { useCallback, useState } from "react";
import { Box, Card, CardContent, CardHeader } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import Grid from "@mui/material/Grid";
import { isBlank, notBlank } from "../../util/ext";
import PanelLoadingIndicator from "../../components/PanelLoadingIndicator";
import LabeledReadOnly from "../../components/LabeledReadOnly";
import makeStyles from "@mui/styles/makeStyles";
import ReadOnlyField from "../../components/ReadOnlyField";
import RipEndpointDialog from "../edit/RipEndpointDialog";
import { mergeRight } from "ramda";

const useStyles = makeStyles(theme => ({
  header: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },

  content: {
    paddingTop: 0,
  },
}));

const RipEndpointCard = ({ project, loading, onUpdate }) => {
  const classes = useStyles();

  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const handleEditClick = useCallback(() => {
    console.log("Handling Edit click...");
    setEditDialogOpen(true);
  }, []);

  const handleEditCancel = useCallback(() => {
    setEditDialogOpen(false);
  }, []);

  const handleEditApply = useCallback(
    async data => {
      //call parent callback to save updated data.
      setEditDialogOpen(false);
      console.log(data);
      const update = mergeRight(project, data);
      console.log(update);
      onUpdate(update);
    },
    [project, onUpdate],
  );

  return (
    <Card raised elevation={4} style={{ height: "100%" }}>
      <CardHeader
        titleTypographyProps={{
          variant: "h6",
          color: "primary",
        }}
        title="RIP Endpoint"
        action={
          <Box display="flex" justifyContent="flex-end" alignItems="center">
            <Tooltip title="Edit RIP Endpoint">
              <IconButton onClick={handleEditClick} size="large">
                <EditIcon color="primary" fontSize="large" />
              </IconButton>
            </Tooltip>
          </Box>
        }
        classes={{ root: classes.header }}
      />
      <CardContent classes={{ root: classes.content }}>
        {loading && <PanelLoadingIndicator />}
        {isBlank(project) && (
          <Box padding={5} fontSize="1.4rem" fontStyle="italic">
            Error Loading RIP Endpoint.
          </Box>
        )}
        {notBlank(project) && (
          <Grid container spacing={3}>
            <Grid item sm={12}>
              <LabeledReadOnly label="RIP Endpoint">
                <ReadOnlyField>{project.ripEndpoint}</ReadOnlyField>
              </LabeledReadOnly>
            </Grid>

            <Grid item sm={12}>
              <LabeledReadOnly label="RIP Endpoint ID">
                <ReadOnlyField>{project.ripEndpointId}</ReadOnlyField>
              </LabeledReadOnly>
            </Grid>
          </Grid>
        )}
      </CardContent>
      {editDialogOpen && (
        <RipEndpointDialog
          open={editDialogOpen}
          project={project}
          onCancel={handleEditCancel}
          onApply={handleEditApply}
        />
      )}
    </Card>
  );
};

export default RipEndpointCard;
